module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.novosMunicipios.length > 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "municipios-container"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.novosMunicipios), function(municipio) {
    return _c('div', {
      staticClass: "municipios-novo"
    }, [_vm._v("\n      - "), _c('strong', [_vm._v(" " + _vm._s(municipio.nome) + " ")])])
  })], 2), _vm._v(" "), _c('vue-snotify')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Municípios Encontrados em que a Fundação BB ainda não possui projetos aprovados:\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62c5025c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/municipiosNovos.vue
// module id = 1921
// module chunks = 2